import { DeviceResponse, DeviceStatus } from 'api/Responses/DeviceResponses';

export type DeviceAction =
  | { type: 'INIT'; payload: DeviceResponse }
  | { type: 'ID'; payload: string }
  | { type: 'USER'; payload: string }
  | { type: 'IMAGE'; payload: string }
  | { type: 'INSPECTION_MANUAL'; payload: File }
  | { type: 'INSPECTION_MANUAL_URL'; payload: string }
  | { type: 'STATUS'; payload: DeviceStatus }
  | { type: 'DESCRIPTION'; payload: string }
  | { type: 'ADDITIONAL_INSPECTION'; payload: string }
  | { type: 'JAPANESE_DESCRIPTION'; payload: string }
  | { type: 'JAPANESE_ADDITIONAL_INSPECTION'; payload: string }
  | { type: 'CANNULATED'; payload: boolean }
  | { type: 'NUM_PARTS'; payload: string }
  | { type: 'DISASSEMBLY'; payload: string }
  | {
      type: 'DEBRIS_INSPECTION';
      payload: boolean;
    }
  | {
      type: 'FUNCTION_TEST';
      payload: boolean;
    }
  | {
      type: 'TORQUE_TEST';
      payload: boolean;
    }
  | {
      type: 'PRONE_TO_DEBRIS';
      payload: boolean;
    };

/**
 * Actions for the part reducer
 */
export const deviceActions = {
  init: (device: DeviceResponse): DeviceAction => ({ type: 'INIT', payload: device }),
  // Update part reference
  id: (id: string): DeviceAction => ({ type: 'ID', payload: id }),
  user: (uid: string): DeviceAction => ({ type: 'USER', payload: uid }),
  image: (url: string): DeviceAction => ({ type: 'IMAGE', payload: url }),
  inspectionManual: (file: File): DeviceAction => ({ type: 'INSPECTION_MANUAL', payload: file }),
  inspectionManualUrl: (url: string): DeviceAction => ({ type: 'INSPECTION_MANUAL_URL', payload: url }),
  status: (status: DeviceStatus): DeviceAction => ({ type: 'STATUS', payload: status }),
  description: (description: string): DeviceAction => ({ type: 'DESCRIPTION', payload: description }),
  additionalInspection: (additionalInspection: string): DeviceAction => ({
    type: 'ADDITIONAL_INSPECTION',
    payload: additionalInspection,
  }),
  japaneseDescription: (description: string): DeviceAction => ({
    type: 'JAPANESE_DESCRIPTION',
    payload: description,
  }),
  japaneseAdditionalInspection: (additionalInspection: string): DeviceAction => ({
    type: 'JAPANESE_ADDITIONAL_INSPECTION',
    payload: additionalInspection,
  }),
  // Update part qty
  cannulated: (cannulated: boolean): DeviceAction => ({ type: 'CANNULATED', payload: cannulated }),
  numParts: (numParts: string): DeviceAction => ({ type: 'NUM_PARTS', payload: numParts }),
  disassemblyInfo: (disassemblyInfo: string): DeviceAction => ({ type: 'DISASSEMBLY', payload: disassemblyInfo }),
  debrisInspection: (debrisInspection: boolean): DeviceAction => ({
    type: 'DEBRIS_INSPECTION',
    payload: debrisInspection,
  }),
  functionTest: (functionTest: boolean): DeviceAction => ({
    type: 'FUNCTION_TEST',
    payload: functionTest,
  }),
  torqueTest: (torqueTest: boolean): DeviceAction => ({
    type: 'TORQUE_TEST',
    payload: torqueTest,
  }),
  proneToDebris: (proneToDebris: boolean): DeviceAction => ({
    type: 'PRONE_TO_DEBRIS',
    payload: proneToDebris,
  }),
};
